import { render, staticRenderFns } from "./AdminsList.vue?vue&type=template&id=cf8323a0&scoped=true&"
import script from "./AdminsList.vue?vue&type=script&lang=js&"
export * from "./AdminsList.vue?vue&type=script&lang=js&"
import style0 from "./AdminsList.vue?vue&type=style&index=0&id=cf8323a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8323a0",
  null
  
)

export default component.exports